import { RouteNames } from "@/RouteNames";

export const rendererLinkToRouteMap: { [key: string]: string } = {
    "link:compressor_link": RouteNames.imageCompressor,
    "link:image_compressor_link": RouteNames.imageCompressor,
    "link:png_compressor_link": RouteNames.pngCompressor,
    "link:jpeg_compressor_link": RouteNames.jpegCompressor,
    "link:image_converter_link": RouteNames.imageConverter,
    "link:image_resizer_link": RouteNames.imageResizer,
    "link:image_enlarger_link": RouteNames.imageEnlarger,
    "link:crop_image_link": RouteNames.cropImage,
    "link:rotate_image_link": RouteNames.rotateImage,
    "link:flip_image_link": RouteNames.flipImage,
    "link:gif_compressor_link": RouteNames.gifCompressor,
    "link:bulk_resize_link": RouteNames.bulkResize,
    "link:color_picker_link": RouteNames.colorPicker,
    "link:pix_converter_ios_link": "https://apps.apple.com/us/app/image-converter-pixconverter/id1570076731",
    "link:pix_converter_android_link": "https://play.google.com/store/apps/details?id=com.freeconvert.image_converter",
};
export const getRouteFormLink = (linkKey: string): string | undefined => {
    return rendererLinkToRouteMap[linkKey];
};
